import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {cardsData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.items.slice(0, 3).map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="group bg-background-50 rounded-lg overflow-hidden no-underline block"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-50/90 text-foreground-700 text-xs rounded">
                  {item.time}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsData.items.slice(3, 5).map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="group bg-background-50 rounded-lg overflow-hidden no-underline flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[200px] h-[160px] sm:h-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}